import { Card } from '@mui/material';
import { TitlePageLayout } from '@/admins/SmartReports/components/Layouts/TitlePage';
import { PageNumber } from '@/admins/SmartReports/components/StaticContent/PageNumber';
import { WatermarkLogo } from '@/admins/SmartReports/components/StaticContent/WatermarkLogo';
import { SmartReportLayouts } from '../Layouts';
import { useEditSmartReport } from './EditSmartReportContext';

export const EditPage = () => {
  const { selectedPage, entity, onComponentLoad } = useEditSmartReport();
  // If layout is not found, fallback to the first layout
  const Layout =
    SmartReportLayouts.find(l => l.id === selectedPage?.layout) || SmartReportLayouts[0];

  // Hide logo and number on title page
  const showFooter = Layout?.id !== TitlePageLayout.id;

  return (
    <Card sx={{ aspectRatio: '16/9', width: '100%', position: 'relative' }}>
      {/* Render the selected layout component with the current page data */}
      {/* Key is used to force re-render when the selected page changes */}
      <Layout.Component
        key={selectedPage?.number || 'default'}
        entity={entity}
        onComponentLoad={onComponentLoad}
      />

      {showFooter && (
        <>
          <WatermarkLogo />
          <PageNumber pageNumber={selectedPage?.number} />
        </>
      )}
    </Card>
  );
};
